import { clsx as cn } from 'clsx';
import * as React from 'react';
import styles from './styles.module.css';
import { UIText2 } from '../../../../typography';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SuggestionDesktopDefaultItem = props => {
  return /*#__PURE__*/_jsxs("li", {
    className: cn(styles['item'], props.isSelected && styles['item-selected']),
    role: "option",
    "aria-selected": props.isSelected,
    tabIndex: -1,
    onClick: props.onClick,
    onMouseLeave: props.onMouseLeave,
    onMouseEnter: props.onMouseEnter,
    onMouseMove: props.onMouseMove,
    "data-testid": "suggesttion-desktop-default-item",
    children: [props.leftIcon && /*#__PURE__*/_jsx("div", {
      className: styles['left-icon'],
      children: props.leftIcon
    }), /*#__PURE__*/_jsxs("div", {
      className: styles['text-area'],
      style: {
        marginLeft: props.iconMargin
      },
      children: [/*#__PURE__*/_jsx("div", {
        className: styles['title'],
        children: props.children
      }), props.subtitle && /*#__PURE__*/_jsx("div", {
        className: styles['subtitle'],
        children: /*#__PURE__*/_jsx(UIText2, {
          color: "gray60_100",
          children: props.subtitle
        })
      })]
    }), props.rightIcon && /*#__PURE__*/_jsx("div", {
      className: styles['right-icon'],
      children: props.rightIcon
    })]
  });
};
SuggestionDesktopDefaultItem.displayName = 'SuggestionDesktopDefaultItem';